import {
  Avatar,
  Card,
  CardContent,
  Typography,
  Grid,
  alpha,
} from "@mui/material";
import React from "react";

function CounterCard({
  title,
  description,
  icon,
  color,
  bgColor,
  onClickHandler,
  isActive,
}) {
  return (
    <Card
      id={description}
      sx={{
        cursor: "pointer",
        borderBottom: !isActive && `1.5px solid ${color}`,
        border: isActive && `1.5px solid ${color}`,
        boxShadow: `0 0 20px 0px ${alpha(bgColor, 0.4)}`,
        mt:"0px"
      }}
      onClick={onClickHandler}
    >
      <CardContent sx={{p: "12px !important"}}>
        <Grid container spacing={3} sx={{justifyContent: "space-between"}}>
          <Grid
            item
            order={{lg: 1, xl: 1, md: 2, sm: 1, xs: 1}}
            maxWidth="150px"
          >
            <Typography color={color} variant="h4">
              {title}
            </Typography>
            <Typography
              color="textSecondary"
              component={"p"}
              sx={{
                width: 140,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textTransform: "uppercase",
                fontSize: 10,
                fontWeight: 600,
              }}
            >
              {description}
            </Typography>
          </Grid>
          <Grid item order={{lg: 1, xl: 1, md: 1, sm: 1, xs: 2}} sx={{pt:5}}>
            <Avatar
              aria-label={`${title} avatar`}
              sx={{
                bgcolor: bgColor,
                color: color,
                width: 50,
                height: 50,
              }}
            >
              {icon}
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default CounterCard;
